import { Button } from '@progress/kendo-react-buttons'
import { FC, useEffect, useState } from 'react'
import { HistoryBody } from '../../../components/layouts'
import { ErrorMessage, ErrorMessages } from '../../../components/parts'
import { HistoryListGateway } from '../../../gateway/building/HistoryListGateway'
import {
  BuildingHistoryActions,
  CommonActions,
  useAppDispatch,
  useAppSelector
} from '../../../stores'
import { BuildingSearchResultList } from './BuildingHistoryItemList'

export interface BuildingHistoryProps {
  footerButtonEvent: () => void
  procurementNo?: string
  subNo?: string
}

export const BuildingHistory: FC<BuildingHistoryProps> = ({
  footerButtonEvent,
  procurementNo,
  subNo
}) => {
  const [skip, setSkip] = useState(0)
  const [errorMessages, setErrorMessages] = useState<ErrorMessage[]>([])
  const buildingHistoryList = useAppSelector(
    (state) => state.buildingHistory.buildingHistoryList
  )
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (procurementNo !== undefined && subNo !== undefined) {
      dispatch(CommonActions.setIsLoading(true))
      HistoryListGateway.getBuildingHistoryList({
        procurementNo,
        subNo
      })
        .then((res) => {
          if (!res.error) {
            dispatch(BuildingHistoryActions.setBuildingHistoryListData(res.data))
          } else {
            if (Array.isArray(res.messages) && res.messages.length > 0) {
              const errorMessages = res.messages.map<ErrorMessage>((message) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              setErrorMessages(errorMessages)
            }
          }
        })
        .finally(() => { dispatch(CommonActions.setIsLoading(false)) })
    }
  }, [dispatch, procurementNo, subNo])

  return (
    <div>
      <HistoryBody
        total={buildingHistoryList.length}
        changeSkip={setSkip}
        skip={skip}
        body={<BuildingSearchResultList skip={skip} />}
        footerButton={<Button onClick={footerButtonEvent}>閉じる</Button>}
      />
      <ErrorMessages type="dialog" messages={errorMessages} />
    </div>
  )
}
